export const getUserName = (): string => {
    return localStorage.getItem('username') ?? '';
}

const frontDeskUsers = [
    'frontdesk.user1',
    'frontdesk.user2',
    'frontdesk.user3',
    'infodesk.user1',
    'infodesk.user2'
];

const adminUsers = [
    'adminuser.stage1',
    'adminuser.stage2',
    'adminuser.stage3',
    'adminuser.stage4',
    'adminuser.stage5',
    'adminuser.stage6',
    'adminuser.stage7',
    'adminuser.stage8',
    'adminuser.stage9',
    'adminuser.stage10',
    'adminuser.stage11',
    'adminuser.stage12',
    'adminuser.stage13',
    'adminuser.stage14',
    'adminuser.stage15',
    'adminuser.stage16',
    'adminuser.stage17',
    'adminuser.stage18',
    'adminuser.stage19',
    'adminuser.stage20',
];

const superAdminUser = [
    'superadmin.user',
    'admin',
];

export enum USER_ROLES {
    FRONT_DESK = 'FRONT_DESK',
    ADMIN = 'ADMIN',
    SUPER_ADMIN = 'SUPER_ADMIN'
}

export const getUserRole = (): string => {
    const username = getUserName();

    if (frontDeskUsers.includes(username)) {
        return USER_ROLES.FRONT_DESK
    }

    if (adminUsers.includes(username)) {
        return USER_ROLES.ADMIN;
    }

    if (superAdminUser.includes(username)) {
        return USER_ROLES.SUPER_ADMIN;
    }

    return USER_ROLES.FRONT_DESK;
}